import React from "react";
import IconActionGroup from "../../../library/IconActionGroup";
import PhaseCreditBadges from "./PhaseCreditBadges";
import {
    StyledPhaseCard,
    StyledPhaseCardContent,
    StyledPhaseName,
} from "./studyPaths.styles";

/**
 * One phase card in the Study Phases list (SPEC1 R2) — name, overall credit result, one chip
 * per non-empty module group, and Edit + Delete shown directly (AC1), same as Re-arrange mode's
 * row — see `PhaseRearrangeRow.js`.
 * @param {object} props.phase A phase row from `useStudyPathPhaseList` (with `*_supplied_credits`).
 * @param {boolean} props.selected Whether this phase is the one shown on the right.
 */
function PhaseCard({ phase, selected = false, onSelect, onEdit, onDelete, editDisabled = false, editDisabledReason, deleteDisabled = false, deleteDisabledReason }) {
    return (
        <StyledPhaseCard
            $selected={selected}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(phase)}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onSelect(phase);
                }
            }}
        >
            <StyledPhaseCardContent>
                <StyledPhaseName>{phase.name}</StyledPhaseName>
                <PhaseCreditBadges phase={phase} />
            </StyledPhaseCardContent>

            <IconActionGroup
                collapseAfterFirst={false}
                actions={[
                    {
                        icon: "edit",
                        ariaLabel: "Edit phase",
                        title: `Edit ${phase.name}`,
                        variant: "solid",
                        disabled: editDisabled,
                        disabledReason: editDisabledReason,
                        onClick: (event) => {
                            if (event) {
                                event.stopPropagation();
                            }
                            onEdit(phase);
                        },
                    },
                    {
                        icon: "trash-alt",
                        ariaLabel: "Delete phase",
                        title: `Delete ${phase.name}`,
                        variant: "destructive",
                        disabled: deleteDisabled,
                        disabledReason: deleteDisabledReason,
                        onClick: (event) => {
                            if (event) {
                                event.stopPropagation();
                            }
                            onDelete(phase);
                        },
                    },
                ]}
            />
        </StyledPhaseCard>
    );
}

PhaseCard.displayName = "PhaseCard";

export default PhaseCard;
